<template>
  <main>
    <header class="header fixed up priority-4 hide-768">
      <button
        class="button-border-gray still-small"
        @click="$router.back()"
      >
        &lt; Go back
      </button>

      <a class="c-pointer priority-3" href="https://www.union.sk" target="_blank">
        <i class="icon icon--union-uzp priority-2"></i>
      </a>
    </header>

    <div class="width-10 flex justify-content-center align-items-start">
      <div class="width-9 f-column mb-children-2 font-gray font-small">
        <h2>Current model</h2>
        <textarea style="min-height: 500px" disabled :value="JSON.stringify(model)"></textarea>

        <h3>Errors</h3>
        <textarea style="min-height: 100px" disabled :value="JSON.stringify(errors)"></textarea>

        <h2>New model</h2>
        <textarea class="font-dark" style="min-height: 500px" v-model="data" placeholder="Enter model..."></textarea>

        <h3>New model errors</h3>
        <textarea style="min-height: 100px" disabled :value="JSON.stringify(dataErrors)"></textarea>

        <button @click="loadModel" class="button-no-shadow button-green">Load model</button>
      </div>
    </div>
  </main>
</template>

<script>
import lead from '@/mixins/lead';

export default {
  name: 'Debug',
  mixins: [lead],
  props: {
    model: { required: true, type: Object },
    errors: { required: true, type: Array },
  },
  data: () => ({ data: '' }),
  computed: {
    kotlinModel() {
      let model = null;
      if (!this.data) return null;
      try {
        const stringModel = this.stringifyModel(JSON.parse(this.data));
        model = this.parseModel(JSON.parse(stringModel));
      } catch (e) {
        console.log('INVALID MODEL');
      }
      return model;
    },
    dataErrors() {
      if (!this.kotlinModel) return [];
      const { validateModelFnName, Validator } = this.$kotlin;
      return new Validator().__proto__[validateModelFnName](this.kotlinModel).toJSON(); // eslint-disable-line
    },
  },
  methods: {
    loadModel() {
      if (this.kotlinModel) {
        this.$emit('new-model', this.kotlinModel);
        this.$nextTick(() => { this.$router.goToStep(this.model.step); });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  main {
    padding-top: 130px;
    padding-bottom: 200px;
  }

  textarea {
    background-color: transparent;
    border-color: darken(#E3E4E6, 10);
  }
</style>
